import { collection, get } from "typesaurus"

export interface UserInvite {
  createdDate: number
  email: string
  expirationDate: number
  firstName: string
  id: string
  lastName: string
  sent: true
  sentAt: number
  userId: string
  isBulkInvitation: boolean
}

const collection_ref = collection<UserInvite>("userInvites")

export const getInviteById = (id: string) => {
  return get(collection_ref, id)
}
